// Shared event-category label map. Referenced by VenueEventChip +
// VenueEventBanner. Colocated so both siblings can import it without
// creating a cycle through GuestMapSurface.js.

export const EVENT_CATEGORY_LABELS = {
  karaoke: 'Karaoke',
  'live-music': 'Live Music',
  'dj-set': 'DJ Set',
  party: 'Party',
  'greek-night': 'Greek Night',
  'wine-tasting': 'Wine Tasting',
  'cultural-event': 'Cultural Event',
  other: 'Event',
};
